export default "__VITE_ASSET__tg28$j3i__"